import { render, staticRenderFns } from "./ModalShiftRating.vue?vue&type=template&id=5756ab6f&"
import script from "./ModalShiftRating.vue?vue&type=script&lang=js&"
export * from "./ModalShiftRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports